/*
 * This draws gray horizontal lines in the middle of the chart. It is used instead of gridlines
 * because we want to ensure they are evenly spaced. You can add an option to chart's options
 * object called horizontalLines to change the default from 3 lines.
 */

const Style = require("@vg-faset/core/styles/export-js.scss");

export default {
	id: "horizontalLines",
	beforeDatasetsDraw: function (chart) {
		let maxLines = 3;

		if (typeof chart.config.options.horizontalLines !== "undefined") {
			maxLines = chart.config.options.horizontalLines;
		}

		const ctxPlugin = chart.chart.ctx;
		const xAxis = chart.scales[chart.config.options.scales.xAxes[0].id];
		const yAxis = chart.scales[chart.config.options.scales.yAxes[0].id];

		let chartMax = chart.config.options.scales.yAxes[0].ticks.max;

		ctxPlugin.strokeStyle = Style.colorLighterGray;

		for (var i = 1; i <= maxLines; i++) {
			ctxPlugin.beginPath();
			let lineAt = (chartMax / (maxLines + 1)) * i;
			lineAt = (lineAt - yAxis.min) * (100 / yAxis.max);
			lineAt = ((100 - lineAt) / 100) * yAxis.height + yAxis.top;
			ctxPlugin.moveTo(xAxis.left, lineAt);
			ctxPlugin.lineTo(xAxis.right, lineAt);
			ctxPlugin.stroke();
		}
	}
};
